import ManageOrders from "./ManageOrders";
export default ManageOrders;
export { default as ManageOrders } from './ManageOrders';